module.exports = __webpack_public_path__ + "static/media/usuario.fa798c30.svg";